// V1.4 (CRC32Auth)。TXはwrite-without-response、RXはnotify。
export const V14_SERVICE_UUID = '0000fff0-0000-1000-8000-00805f9b34fb'
export const V14_SERVICE_SHORT = 'fff0'
export const V14_TX_CHARACTERISTIC = '0000fff1-0000-1000-8000-00805f9b34fb'
export const V14_RX_CHARACTERISTIC = '0000fff2-0000-1000-8000-00805f9b34fb'

// 旧 AES (legacy)
export const AES_SERVICE_UUID = '6e400001-b5a3-f393-e0a9-e50e24dcca9e'
export const AES_TX_CHARACTERISTIC = '6e400002-b5a3-f393-e0a9-e50e24dcca9e'
export const AES_RX_CHARACTERISTIC = '6e400003-b5a3-f393-e0a9-e50e24dcca9e'
